import React from 'react';
import {firebaseRoot} from './utils/firebase-utils';
import ReactFireMixin from 'reactfire';

const UserAuth = React.createClass({
    mixins: [
        ReactFireMixin
    ],

    contextTypes: {
        history: React.PropTypes.object.isRequired,
        location: React.PropTypes.object.isRequired
    },

    componentWillMount() {
        if (!firebaseRoot.getAuth()) {
            this.context.history.replaceState({nextPathname: this.context.location.pathname}, '/login');
        }
    },

    render() {
        return this.props.children;
    }
});

export default UserAuth;


/** WEBPACK FOOTER **
 ** ./src/UserAuth.js
 **/